<template>
  <div class="selection-display">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'SelectionDisplay',

  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
@use 'mixins/typography';
.selection-display {
  display: flex;
  align-items: center;
  height: 36px;
  padding: 0 14px 2px 14px;
  color: colors.$color-grey-500;
  border-radius: settings.$border-radius;

  @include typography.typography-15-normal;
}
</style>
